// Module
var code = "<div id=notification-slider><div class=notification-slider><div class=initial-hide slide-down-on-event={{slideDownEvents}} slide-up-after-event=3000><h3 class=h3>{{eventMessage}}</h3></div></div></div>";
// Exports
module.exports = code;